import { Editor, Element, Transforms } from 'slate'
import { AlignKey, CustomElement, EditorType, MarkKey } from './richTextEditor.types'

// Проверяет, активен ли определенный формат (жирный, курсив и т. д.)
const isMarkActive = (editor: EditorType, format: MarkKey) => {
  return !!Editor.marks(editor)?.[format]
}

// Проверяет, активировано ли определенное выравнивание текста (лево, центр, право)
const isActiveTextAlign = (editor: EditorType, format: AlignKey) => {
  const { selection } = editor
  if (!selection) {
    return false
  }
  const match = Array.from(
    Editor.nodes(editor, {
      at: Editor.unhangRange(editor, selection), // Убираем зависание курсора при выделении
      match: (node) => {
        return !Editor.isEditor(node) && Element.isElement(node) && node?.align === format
      },
    })
  )
  return !!match?.[0]
}

// Включает или выключает стиль текста (жирный, курсив и т. д.)
const toggleMark = (editor: EditorType, format: MarkKey) => {
  const isActive = isMarkActive(editor, format)
  if (isActive) {
    editor.removeMark(format)
  } else {
    editor.addMark(format, true)
  }
}

// Устанавливает или снимает выравнивание текста (лево, центр, право)
const toggleTextAlign = (editor: EditorType, format: AlignKey) => {
  const isAlign = ['left', 'center', 'right'].includes(format)
  const isActive = isActiveTextAlign(editor, format)
  let align: AlignKey | undefined
  if (isAlign) {
    align = isActive ? undefined : (format as AlignKey)
  }
  let newProperties: Partial<CustomElement> = {}
  if (align) {
    newProperties['align'] = align
  }
  // Применяем изменения к выделенному тексту
  Transforms.setNodes<Editor>(editor, newProperties)
}

// Устанавливает размер шрифта для выделенного текста
const toggleFontSize = (editor: EditorType, fontSize: number) => {
  editor.addMark('fontSize', fontSize)
}

// Устанавливает цвет текста для выделенного фрагмента
const toggleTextColor = (editor: EditorType, textColor: string) => {
  editor.addMark('color', textColor)
}

// Получает текущий размер шрифта выделенного текста
const getCurrentFontSize = (editor: EditorType): number | null => {
  const marks = Editor.marks(editor)
  return marks?.fontSize || null
}

const richTextEditorUtils = {
  toggleMark,
  isMarkActive,
  getCurrentFontSize,
  toggleTextAlign,
  isActiveTextAlign,
  toggleFontSize,
  toggleTextColor,
}

export default richTextEditorUtils
